import React from 'react';

import { faEdit } from '~components/icon';
import { buildColumn, EditableColumnConfig } from '~components/table-view';

import { UserRow } from '~care-workers/reducers/users';

import AccessTags from '../components/AccessTags';

const columnsFactory = (users: UserRow[], toggleModal: (id: string) => void) => {
  const columns: EditableColumnConfig[] = [
    {
      id: 'name',
      header: 'Name',
      type: 'text',
      props: {
        meta: {
          onClick: (row: { id: string }) => toggleModal(row.id),
          hoverIcon: faEdit,
        },
      },
    },
    {
      id: 'createdby_id',
      header: 'Created By',
      type: 'text',
      accessorFn: (row) => users.find((user) => user.id === row.createdby_id)?.full_name ?? 'N/A',
    },
    {
      id: 'expires_at',
      header: 'Expires At',
      type: 'datetime',
    },
    {
      id: 'access_list',
      header: 'Access Tags',
      type: 'custom',
      props: {
        meta: {
          renderCustom: (_isEditing = false, row: any): React.ReactElement | null => {
            return React.createElement(AccessTags, { rowData: row });
          },
        },
      },
    },
    {
      id: 'is_deleted',
      header: 'Status',
      type: 'text',
      accessorFn: (row) => (row.is_deleted ? 'Deleted' : 'Active'),
    },
  ];
  return columns.map(buildColumn);
};
export default columnsFactory;
